module.exports = __webpack_public_path__ + "img/hr-defender-robot-mask.c5debe22.png";